// React Lazily
import { lazily } from 'react-lazily';

// Interfaces
import { IRoute } from 'routes/route.interface';

// Constant
import { ASSESSMENT_MODULE, ASSESSMENT_URL } from 'constant/url.constant';
import { LAYOUT } from 'constant/layout.constant';

// UI
const {
  AssessmentIndex,
  AssessmentDetail,
  AssessmentCompetencyUnitDetail,
  AssessmentDocumentPreview,
  StartAssessmentPhaseDetail,
} = lazily(() => import('pages/back-office/assessment'));

const assessmentRoutes: IRoute[] = [
  {
    path: ASSESSMENT_URL.INDEX,
    component: AssessmentIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: ASSESSMENT_MODULE,
      requireAuth: true,
      attrs: { label: 'assessment.listOfAssessment', accessCodes: [332], noBackOfficeCard: true },
    },
  },
  {
    path: `${ASSESSMENT_URL.INDEX}/:id`,
    component: AssessmentDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: ASSESSMENT_MODULE,
      requireAuth: true,
      attrs: { label: 'assessment.detailOfAssessment', accessCodes: [332] },
    },
  },
  {
    path: `${ASSESSMENT_URL.INDEX}/:assessmentId/detail/:competencyUnitId`,
    component: AssessmentCompetencyUnitDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: ASSESSMENT_MODULE,
      requireAuth: true,
      attrs: { label: 'assessment.detailOfAssessment', accessCodes: [332] },
    },
  },
  {
    path: `${ASSESSMENT_URL.INDEX}/:assessmentId/document-preview/:formType/:preparationId`,
    component: AssessmentDocumentPreview,
    layout: LAYOUT.EMPTY,
    exact: true,
    meta: {
      module: ASSESSMENT_MODULE,
      requireAuth: true,
      attrs: { label: 'assessment.detailOfAssessment', accessCodes: [332] },
    },
  },
  {
    path: `${ASSESSMENT_URL.INDEX}/:assessmentId/start-assessment/:competencyUnitId`,
    component: StartAssessmentPhaseDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: ASSESSMENT_MODULE,
      requireAuth: true,
      attrs: { label: 'assessment.detailOfAssessment', accessCodes: [332] },
    },
  },
];

export { assessmentRoutes };
